import React, { useState } from "react";
import { Button, Card, Form } from "react-bootstrap";

function FillInBlank({ sentence, correctAnswer, explanation, index }) {
  const [userAnswer, setUserAnswer] = useState("");
  const [feedback, setFeedback] = useState("");
  const [showExplanation, setShowExplanation] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (userAnswer.trim().toLowerCase() === correctAnswer.toLowerCase()) {
      setFeedback("Correct!");
      setShowExplanation(true);
    } else {
      setFeedback("Incorrect. Try again!");
      setShowExplanation(false);
    }
  };

  return (
    <Card className="fill-in-blank-card">
      <Card.Body style={{ backgroundColor: "#934cce5e" }}>
        <Card.Title>{index}. Fill in the Blank</Card.Title>
        <Card.Text>{sentence.replace("_________", "______")}</Card.Text>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formUserAnswer">
            <Form.Control
              type="text"
              placeholder="Enter your answer"
              style={{
                backgroundColor: "#a24dd386",
                borderColor: "black",
                MarginColor: "rgba(81, 5, 100, 0.459)",
              }}
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
            />
          </Form.Group>
          <Button variant="primary" type="submit" style={{ marginTop: "10px" }}>
            Submit
          </Button>
        </Form>
        {feedback && (
          <div
            style={{
              marginTop: "10px",
              color: feedback === "Correct!" ? "green" : "red",
            }}
          >
            {feedback}
          </div>
        )}
        {showExplanation && (
          <Card.Text style={{ marginTop: "10px" }}>{explanation}</Card.Text>
        )}
      </Card.Body>
    </Card>
  );
}

export default FillInBlank;
